var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataLiberation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234 0C248.667 0 263.333 0 278 0C378.269 12.5418 449.769 64.5418 492.5 156C502.796 181.184 509.296 207.184 512 234C512 248.667 512 263.333 512 278C499.458 378.269 447.458 449.769 356 492.5C330.816 502.796 304.816 509.296 278 512C263.333 512 248.667 512 234 512C133.731 499.458 62.2312 447.458 19.5 356C9.20393 330.816 2.70393 304.816 0 278C0 263.333 0 248.667 0 234C12.5418 133.731 64.5418 62.2312 156 19.5C181.184 9.20393 207.184 2.70393 234 0Z",
    fill: "#39C449"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 56,
    width: 400,
    height: 400
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M456 56H56V456H456V56Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.669 206H306.003V106H206.003V206H139.336L256.003 322.666L372.669 206ZM139.336 356V389.333H372.669V356H139.336Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLiberation);
export default __webpack_public_path__ + "static/media/dataLiberation.2f5ac4b1e6507a0221441f62b682e440.svg";
export { ForwardRef as ReactComponent };